module.exports = __webpack_public_path__ + "img/services-5.d18708f1.jpg";